export const githubUsername = "RadekBubienko";